import React, { useState, useEffect } from 'react'
import ButterToast, { Cinnamon } from 'butter-toast'
import FormField from '@CommonComponents/FormField'
import { useStateValue } from '../state'
import { client } from '@Utils'
import { ltiLogs as endpoints } from '@URLS'
import { Pagination } from '@CommonComponents'

const LogTable = () => {
  // Main Context
  const [currentState, dispatch] = useStateValue()
  // Local state for search field
  const [searchLogValue, setSearchLogValue] = useState('')
  const [searchLogQuery, setSearchLogQuery] = useState('')
  // Local state for pagination
  const [paginationRate, setPaginationRate] = useState(0)
  const [totalLogs, setTotalLogs] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)

  useEffect(() => {
    const fetchLogs = async () => {
      let formData = new FormData()
      formData.append('logId', searchLogQuery)
      formData.append('currentPage', currentPage)
      if (currentState.userId) {
        formData.append('userId', currentState.userId)
      }
      try {
        let response = await client.post(endpoints.getLtiLogs(), formData)
        setPaginationRate(response.data.pagRate)
        setTotalLogs(response.data.total)
        dispatch({ type: 'updateLogs', logArray: response.data.logs })
      } catch (err) {
        console.log(err)
        ButterToast.raise({
          content: (
            <Cinnamon.Crunch
              title="Error"
              content={`There was an error trying to get the logs. Please refresh the page. ${err}`}
              scheme={Cinnamon.Crisp.SCHEME_RED}
              icon={<i className="far fa-exclamation-triangle fa-3x" />}
            />
          ),
        })
      }
    }
    fetchLogs()
  }, [searchLogQuery, currentPage])

  let logRows = currentState.logs.map(log => ({
    id: log.id,
    time: log.time,
    course: log.coursenum,
    contextId: log.params.context_id,
    contextTitle: log.params.context_title,
    roles: log.roles,
  }))

  let columns = [
    'Log ID',
    'Launch Time (UTC)',
    'Course',
    'Context ID',
    'Context Title',
    'Roles',
    'Actions',
  ]

  return (
    <div>
      <div>
        <FormField
          name="logId"
          label="Log ID: "
          handler={event => setSearchLogValue(event.target.value)}
        />
        <a
          className="btn btn-myed btn-primary btn-primary-myed"
          onClick={() => setSearchLogQuery(searchLogValue)}
        >
          Search
        </a>
      </div>
      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        rate={paginationRate}
        total={totalLogs}
      />
      <table className="table table-striped table-hover table-condensed">
        <thead>
          <tr>
            {columns.map((col, i) => (
              <th key={i}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {logRows.map(row => (
            <tr key={`${row.id}`}>
              <td>{row.id}</td>
              <td>{row.time}</td>
              <td>{row.course}</td>
              <td>{row.contextId}</td>
              <td>{row.contextTitle}</td>
              <td>{row.roles}</td>
              <td>
                <a
                  className="btn btn-myed btn-primary btn-primary-myed"
                  onClick={() =>
                    dispatch({ type: 'selectLog', selectedLog: row.id })
                  }
                >
                  View
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        rate={paginationRate}
        total={totalLogs}
      />
    </div>
  )
}
export default LogTable
